import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";
import { useApi } from "../../../api/use-api";
import { getUsersByDate } from "../../../api/statistics/statistics";
import useScreenSize from "../../../utils/use-screen";
import { Link } from "react-router-dom";
import { HistoryEdu } from "@mui/icons-material";
import { Button } from "../../../components/button/button";

export const Dashboard: FC = () => {
  const [date, setDate] = useState<string>();

  const { isDesktop } = useScreenSize();
  const { api: getUsersByDateApi, data, loading } = useApi(getUsersByDate);

  useEffect(() => {
    const today = new Date();
    const startDate = today.toJSON().slice(0, 10);
    getUsersByDateApi({
      startDate,
    });
    setDate(startDate);
  }, [getUsersByDateApi]);

  const move = useCallback(
    (isForward: boolean, current: string) => {
      const day = new Date(current);
      if (isForward) {
        day.setDate(day.getDate() + 1);
      } else {
        day.setDate(day.getDate() - 1);
      }
      getUsersByDateApi({
        startDate: day.toJSON().slice(0, 10),
      });
      setDate(day.toJSON().slice(0, 10));
    },
    [getUsersByDateApi],
  );
  return (
    <Paper
      component={Grid}
      width={isDesktop ? "80vw" : "100vw"}
      overflow={"scroll"}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={3}
      >
        <Button
          loading={loading}
          variant="outlined"
          onClick={() => date && move(false, date)}
        >
          last
        </Button>
        <Typography variant="h6">{date}</Typography>
        <Button
          loading={loading}
          variant="outlined"
          onClick={() => date && move(true, date)}
        >
          next
        </Button>
      </Box>
      <TableContainer>
        <Table aria-labelledby="tableTitle" size={"small"}>
          <TableHead>
            <TableRow>
              <TableCell>Number</TableCell>
              <TableCell>Account ID</TableCell>
              <TableCell>logs</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.map((item, key) => (
                <TableRow key={key}>
                  <TableCell>{key + 1}</TableCell>
                  <TableCell>
                    <Link to={"/app/users/?accountId=" + item.accountId}>
                      {item.accountId}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                      to={`/app/logs/?accountId=${item.accountId}&date=${date}`}
                    >
                      <HistoryEdu />
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
